const CART_PATH = '/cart/';

const generateUniquePath = (pages, rawPath, locale) => {
  const slashesRegExp = /^\/+|\/+$/g;
  const reservedPaths = ['/ws/', '/e/'];
  const trimmedPath = rawPath.replace(slashesRegExp, '');
  const basePath = locale ? `/${locale}/${trimmedPath}/` : `/${trimmedPath}/`;
  const pathPrefix = locale ? `/${locale}/${trimmedPath}-` : `/${trimmedPath}-`;
  const cartPath = `${locale ? `/${locale}` : ''}${CART_PATH}`;

  const existingPaths = new Set(pages.map((page) => page?.path).filter(Boolean));

  const isPathAvailable = (testPath) =>
    !existingPaths.has(testPath) &&
    !reservedPaths.includes(testPath) &&
    testPath.toLowerCase() !== cartPath;

  const getNextNumberedPath = () => {
    const maxIndex = pages
      .filter((page) => page?.path && page.path.startsWith(pathPrefix))
      .reduce((max, page) => {
        const pathSuffix = page.path.replace(pathPrefix, '').replace(slashesRegExp, '');
        const pathIndex = parseInt(pathSuffix, 10);
        const validIndex =
          Number.isInteger(pathIndex) && pathIndex > 0 && pathIndex.toString() === pathSuffix
            ? pathIndex
            : 0;
        return Math.max(max, validIndex);
      }, 1);

    let candidateIndex = Math.max(2, maxIndex + 1);
    let candidatePath = `${pathPrefix}${candidateIndex}/`;

    while (!isPathAvailable(candidatePath)) {
      candidateIndex += 1;
      candidatePath = `${pathPrefix}${candidateIndex}/`;
    }

    return candidatePath;
  };

  if (
    !isPathAvailable(basePath) ||
    pages.some((page) => page?.path && page.path.startsWith(pathPrefix))
  ) {
    return getNextNumberedPath();
  }

  return basePath;
};

export default generateUniquePath;
